import React from 'react';
import PropTypes from 'prop-types';

const TabButton = ({ active, label, count, warn, onClick }) => (
  <button className={`nav-link ${active ? 'active' : ''}`} onClick={onClick}>
    {label}
    {count !== undefined && <span className={`main-tab-badge ${warn ? 'warn' : ''}`}>{count}</span>}
  </button>
);

TabButton.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  warn: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const MainTabs = ({ activeTab, summary, onChange }) => (
  <div className="package-assignment-tabs">
    <nav className="nav nav-tabs">
      <TabButton
        active={activeTab === 'assigned'}
        label="Assigned Returns"
        count={summary?.assignedCount}
        onClick={() => onChange('assigned')}
      />
      <TabButton
        active={activeTab === 'unassigned'}
        label="Unassigned Returns (Bizbelly)"
        count={summary?.unassignedCount}
        warn
        onClick={() => onChange('unassigned')}
      />
    </nav>
  </div>
);

MainTabs.propTypes = {
  activeTab: PropTypes.oneOf(['assigned', 'unassigned']).isRequired,
  summary: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default MainTabs;
